import React from 'react'
import { useTranslate } from 'react-admin'
import LocalizedInputText from 'ui-shared/LocalizedFields/LocalizedInputText'
import LocalizedRichInputText from 'ui-shared/LocalizedFields/LocalizedRichInputText'
import KAccordion from 'ui-shared/accordions/KAccordion'
import { Customization } from 'services/api/entities/events/types/internal/event-models'
import { useFormContext } from 'react-hook-form'

type Props = {
  source: string
  customization?: Customization
}

const CustomizationInput: React.FC<Props> = (props) => {
  const translate = useTranslate()
  const { getValues } = useFormContext()

  function hasItems() {
    return !!getValues(`${props.source}.name`)
  }

  return (
    <KAccordion
      accordionTitle={translate('form.headers.customization')}
      shoulDisplayAlertIcon={hasItems()}
      defaultExpanded={hasItems()}
    >
      <div style={{ width: '100%' }}>
        <LocalizedInputText
          source={`${props.source}.name`}
          label="form.fields.customizationName"
        />
        {props.customization?.name ? (
          <LocalizedRichInputText
            source={`${props.source}.description`}
            label="form.fields.customizationDescription"
          />
        ) : null}
      </div>
    </KAccordion>
  )
}

export default CustomizationInput
